'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, TextLink } from '@petsmart-ui/sparky';
import { useAuthSignInClick } from '@libs/common-next';
import TreatsRewardsIcon from '../shared/treats-rewards.icon.svg';
import './unauthenticated.scss';
const TREATS_REWARDS_HREF = '/treats-rewards';
type UnauthenticatedProps = {
  onAction: () => void;
};
export function Unauthenticated(t0) {
  const $ = _c(22);
  const {
    onAction
  } = t0;
  const {
    isAuth0Enabled,
    handleSignInClick
  } = useAuthSignInClick();
  let t1;
  if ($[0] !== handleSignInClick || $[1] !== onAction) {
    t1 = () => {
      onAction();
      handleSignInClick();
    };
    $[0] = handleSignInClick;
    $[1] = onAction;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleGuestSignInClick = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TreatsRewardsIcon aria-hidden="true" className="account-unauthenticated__icon" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onAction) {
    t3 = <a href={TREATS_REWARDS_HREF} aria-label="Treats Rewards" className="account-unauthenticated__icon-link" onClick={onAction}>{t2}</a>;
    $[4] = onAction;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="account-unauthenticated__text-accent">loyalty program</span>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onAction) {
    t5 = <TextLink variant="secondary" href={TREATS_REWARDS_HREF} className="account-unauthenticated__link" onClick={onAction}>Join our {t4}{" & earn points every time you shop!"}</TextLink>;
    $[7] = onAction;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = isAuth0Enabled ? "Sign in or create account" : "Sign in";
  const t7 = isAuth0Enabled ? "Sign in or create account" : "Sign in";
  const t8 = isAuth0Enabled ? "account-unauthenticated__sign-in-button account-unauthenticated__sign-in-button--auth0" : "account-unauthenticated__sign-in-button";
  let t9;
  if ($[9] !== handleGuestSignInClick || $[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
    t9 = <Button variant="primary" aria-label={t6} text={t7} className={t8} onClick={handleGuestSignInClick} type="button" />;
    $[9] = handleGuestSignInClick;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isAuth0Enabled || $[15] !== onAction) {
    t10 = !isAuth0Enabled && <Button aria-label="Create account" text="Create account" className="account-unauthenticated__create-account-button" onClick={onAction} href="/create-account" />;
    $[14] = isAuth0Enabled;
    $[15] = onAction;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t3 || $[19] !== t5 || $[20] !== t9) {
    t11 = <div className="account-unauthenticated">{t3}{t5}{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t3;
    $[19] = t5;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}